import React, { useEffect, useState } from "react";
import Mapir from "mapir-react-component";
import { Link } from "react-router-dom";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvents,
} from "react-leaflet";
import Spinner from "../Spinner/Spinner";
// import "leaflet/dist/leaflet.css"

const App = (props) => {
  const [currentLocation, setCurrentLocation] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState([]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setCurrentLocation([latitude, longitude]);
      });
    }
    if (props.userLocation.lat) {
      setSelectedLocation([props.userLocation.lat, props.userLocation.lng]);
    }
  }, []);

  const locateMe = () => {
    props.setMapLoading(true);
    navigator.geolocation.getCurrentPosition((position) => {
      const { latitude, longitude } = position.coords;
      setCurrentLocation([latitude, longitude]);
      props.setMapLoading(false);
    });
  };

  let positions = [];
  props.data.map((item) => positions.push([item.latitude, item.longitude]));
  return (
    <>
      {props.mapLoading ? (
        <Spinner />
      ) : (
        <div className="servicesMap">
          <div className="App">
            <img
              src="/public/assets/locateme.png"
              className="locateMe"
              onClick={locateMe}
            />
            <MapContainer
              center={
                props.userLocation.lat
                  ? [props.userLocation.lat, props.userLocation.lng]
                  : currentLocation
                  ? currentLocation
                  : [32.4279, 53.688]
              }
              zoom={props.userLocation.lat ? 25 : 13}
              style={{
                width: "calc(100% - 2rem)",
                maxHeight: "88%",
                margin: "0 1rem",
                borderRadius: "8px",
              }}
            >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              {props.userLocation.lat ? (
                <Marker
                  position={[props.userLocation.lat, props.userLocation.lng]}
                />
              ) : (
                ""
              )}
              {props.data.map((shop, index) => (
                <>
                  {shop.latitude !== null && shop.longitude !== null ? (
                    <>
                      <Marker
                        position={[shop.latitude, shop.longitude]}
                        key={index}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ))}
            </MapContainer>
          </div>
        </div>
      )}
    </>
  );
};

export default App;
